import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import { TypeAsserter } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import * as gql from './gql'
import type { TypeParams } from './types'

@ngCore.Injectable({ providedIn: 'root' })
export class Api implements ec.models.Api<TypeParams> {
  // TODO: The zones query returns a response of type { items: Zone[],
  // nextCursor?: string }. To align with the expected return type of the list
  // method (Zone[]), we map the response here.
  // Pagination by cursor should be implemented
  /** @inheritdoc */
  public list = ec.models.Api.list.using.nothingButContext<TypeParams>(
    context => {
      if (!context) {
        return rxjs.of([])
      }
      return gql.queries.zones
        .execute({
          tenantId: context.tenantId,
        })
        .pipe(rxjs.map(({ items }) => items))
    },
  )

  /** @inheritdoc */
  public create: ec.models.Api<TypeParams>['create'] = (context, input) => {
    TypeAsserter.assertIsNotNullish(context)

    return gql.mutations.createZone.executor({
      input: gql.inputs.zone.INPUT.getGqlFrom(input),
      tenantId: context.tenantId,
    })
  }

  /** @inheritdoc */
  public update: ec.models.Api<TypeParams>['update'] = (
    context,
    { id, updates },
  ) => {
    TypeAsserter.assertIsNotNullish(context)

    return gql.mutations.updateZone.executor({
      tenantId: context.tenantId,
      updateZoneId: id,
      updates: gql.inputs.zone.UPDATES.getGqlFrom(updates),
    })
  }

  /** @inheritdoc */
  public delete: ec.models.Api<TypeParams>['delete'] = (context, id) => {
    TypeAsserter.assertIsNotNullish(context)
    return gql.mutations.deleteZone.executor({
      deleteZoneId: id,
      tenantId: context.tenantId,
    })
  }

  /** @inheritdoc */
  public getAttributes: ec.models.Api<TypeParams>['getAttributes'] = () =>
    rxjs.of([
      ec.models.Attribute.fromKey<TypeParams>('name', {
        isSortable: true,
        name: 'Name',
      }),
      ec.models.Attribute.fromKey<TypeParams>('alias', {
        isSortable: true,
        name: 'Alias',
      }),
      ec.models.Attribute.fromKey<TypeParams>('code', {
        isSortable: true,
        name: 'Code',
      }),
      ec.models.Attribute.fromKey<TypeParams>('description', {
        name: 'Description',
      }),
    ])
}
